import $resolve from "ng";

export default (_options) => {
  const $timeout = $resolve("$timeout");
  const $q = $resolve("$q");
  const $http = $resolve("$http");
  const deferred = $q.defer();
  $http.defaults.useXDomain = true;
  $http.defaults.crossOrigin = "anonymous";
  if (typeof _options === "string" || _options instanceof String) {
    _options = {
      url: _options,
    };
  }
  const options = Object.assign(
    {
      get: false,
      useXDomain: true,
      crossOrigin: "anonymous",
      url: "about:blank",
      attempts: 0,
      multiplier: 1.8,
      maxAttempts: 3,
      delay: 1000,
      callback() {},
    },
    _options
  );
  (function ping() {
    $timeout(
      function () {
        $http[options.get ? "get" : "head"](options.url).then(
          (response) => {
            deferred.resolve(response);
            if (options.callback) options.callback(response);
          },
          (response) => {
            deferred.notify(++options.attempts);
            if (options.attempts < options.maxAttempts) ping();
            else deferred.reject(response);
          }
        );
      },
      (options.delay *= options.multiplier),
      false
    );
  })();
  return deferred.promise;
};
